import React from "react";

import styles from "./HeaderBurger.module.scss";
import data from "./../../DropdownsData.json";
import Dropdown from "../../../../UI/Dropdown/Dropdown";
import { Link } from "react-router";

const HeaderBurger: React.FC = () => {
  const [isBurgerActive, setIsBurgerActive] = React.useState(false);

  const dropdownsData = data[0]?.dropdownsData || [];

  React.useEffect(() => {
    if (isBurgerActive) {
      document.body.classList.add("lock");
    } else {
      document.body.classList.remove("lock");
    }

    return () => {
      document.body.classList.remove("lock");
    };
  }, [isBurgerActive]);

  return (
    <>
      <div className={styles.body}>
        <Link to="/" className={styles.logo}>
          <img src="/img/header/logo.svg" alt="Тканополис" />
        </Link>
        <div
          className={isBurgerActive ? `${styles.burger} ${styles.active}` : styles.burger}
          onClick={() => setIsBurgerActive(!isBurgerActive)}
        >
          <span />
        </div>
      </div>
      <div onClick={() => setIsBurgerActive(false)} className={isBurgerActive ? `${styles.menu} ${styles.active}` : styles.menu}>
        <div onClick={(e: any) => e.stopPropagation()} className={styles.block}>
          <div className={styles.content}>
            <ul className={styles.list}>
              {dropdownsData.map((data: any) => {
                const hasLink = data.link && data.link.trim() !== "";

                return (
                  <li key={data.id}>
                    {hasLink ? (
                      <a href={data.link}>
                        <Dropdown mode="headerDropdown" title={data.title} />
                      </a>
                    ) : (
                      <Dropdown
                        mode="headerDropdown"
                        title={data.title}
                        content={
                          data.content?.map((contentItem: any) => ({
                            id: contentItem.id,
                            text: contentItem.text,
                            link: contentItem.link,
                          })) || []
                        }
                        extraContent={
                          data.extraContent?.map((extra: any) => ({
                            id: extra.id,
                            extraTitle: extra.extraTitle,
                            content: extra.content,
                          })) || []
                        }
                      />
                    )}
                  </li>
                );
              })}
            </ul>
            <ul className={styles.info}>
              <li className={styles.item}>
                <Link to="/schemas">Схемы и выкройки</Link>
              </li>
              <li className={styles.item}>
                <Link to="/gifts">Подарочные сертификаты</Link>
              </li>
              <li className={styles.item}>
                <Link to="/write-to-us">Написать нам</Link>
              </li>
              <li className={styles.item}>
                <Link to="/write-to-manager">Написать руководителю</Link>
              </li>
              <li className={styles.item}>
                <Link to="/contacts">Контакты</Link>
              </li>
              <li className={styles.item}>
                <Link to="/about-us">О нас</Link>
              </li>
            </ul>
            <div className={styles.contacts}>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderBurger;
